<template>
  <div class="c-video">
    <iframe
      v-if="src"
      :src="src.text.text"
      width="640"
      height="360"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      ref="videoPlayer"
    >
    </iframe>
  </div>
</template>

<script>
import Vimeo from '@vimeo/player';

export default {
  name: 'TheVideoPlayer',

  props: {
    src: Object,
    currentTime: String,
  },

  watch: {
    currentTime(newTime) {
      new Vimeo(this.$refs.videoPlayer).setCurrentTime(newTime);
    },
  },
};
</script>


<style scoped>
.c-video {
    overflow:hidden;
    padding-bottom:56.25%;
    position:relative;
    height:0;
}
.c-video iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
}
</style>
